import { Button } from '@gsa/afp-component-library';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { emDashUnicode } from '@gsa/afp-shared-form-utils';
import { setCustomerChange } from '../../../reducers/additionals-reducer';
import {
  ADDITIONAL_REQUEST_STATUS,
  fundingLabel,
} from '../utils/additional-utils';
import AdditionalRequestStatusBadge from '../additionals-status-badge';
import { useCurrentUser } from '@gsa/afp-shared-ui-utils';
import { UserTypes, UserRoles } from '../../../constants';
import Moment from 'moment';
import { isExistInRoles } from '../utils/additional-utils';
export default function SelectedVehicleDetails() {
  const { selectedCustomerAccount, additionalsDraftData } = useSelector(
    (state) => state.additionalsReducer,
  );
  const { requestId } = useParams();
  const dispatch = useDispatch();
  const { currentUser } = useCurrentUser();
  const isGSAEmployee =
    currentUser?.userType?.id === UserTypes.GSA_EMPLOYEE ||
    currentUser?.roles?.some(
      (role) =>
        role.name === UserRoles.OVERSIGHT_BUSINESS_ANALYST ||
        role.name === UserRoles.SITE_ADMIN ||
        role.name === UserRoles.ORDERING_ADMIN,
    );

  const customerChange =
    additionalsDraftData?.requestStatusCode ===
      ADDITIONAL_REQUEST_STATUS.DRAFT ||
    additionalsDraftData?.requestStatusCode ===
      ADDITIONAL_REQUEST_STATUS.RETURNED ||
    !requestId;

  const notFunded =
    additionalsDraftData?.fundingStatus &&
    additionalsDraftData?.fundingStatus !== 'FUNDED';

  const roles = currentUser?.roles || [];
  const isEmployee = currentUser?.userType.id === UserTypes.GSA_EMPLOYEE;

  const isOrderingAdmin = isExistInRoles(roles, UserRoles.ORDERING_ADMIN);
  const isSiteAdmin = isExistInRoles(roles, UserRoles.SITE_ADMIN);

  // Customer type users
  const isCustomerUser =
    isExistInRoles(roles, UserRoles.CUSTOMER_ADMINISTRATOR) ||
    isExistInRoles(roles, UserRoles.CUSTOMER_FLEET_MANAGER);
  const editUsers = isCustomerUser || isOrderingAdmin || isSiteAdmin;
  return (
    <>
      <div className="grid-row grid-gap flex-justify">
        <div className="grid-col-12 padding-top-1 padding-bottom-1">
          <div className="display-flex flex-column" data-testid="data-section">
            <div>
              <span className="text-primary title-l">
                {selectedCustomerAccount?.customerName}|{' '}
                {selectedCustomerAccount?.customerAccountId}
              </span>
              {additionalsDraftData?.requestStatusCode && (
                <span className="margin-left-2">
                  <AdditionalRequestStatusBadge
                    requestStatus={additionalsDraftData?.requestStatusCode}
                  />
                </span>
              )}
              {customerChange && editUsers && (
                <span className="margin-left-2">
                  <Button
                    variant="unstyled"
                    label="Change customer account number"
                    leftIcon={{
                      name: 'edit',
                      type: 'button',
                    }}
                    onClick={() => {
                      dispatch(setCustomerChange(true));
                    }}
                  />
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="grid-col-12 padding-top-1 padding-bottom-6">
          {additionalsDraftData && (
            <div className="text-primary title-m">
              Additional request ID:
              {` ${additionalsDraftData?.additionalRequestNumber || ''}`}
            </div>
          )}
        </div>
        <div className="grid-col-2 padding-top-0">
          <div className="display-flex flex-column" data-testid="data-section">
            <strong>Agency</strong>
            <div>
              {selectedCustomerAccount?.agencyCode} -{' '}
              {selectedCustomerAccount?.agencyName}
            </div>
          </div>
        </div>
        <div className="grid-col-2 padding-top-0">
          <div className="display-flex flex-column" data-testid="data-section">
            <strong>Bureau</strong>
            <div>
              {selectedCustomerAccount?.bureauCode} -{' '}
              {selectedCustomerAccount?.bureauName}
            </div>
          </div>
        </div>
        <div className="grid-col-2 padding-top-0">
          <div className="display-flex flex-column" data-testid="data-section">
            <strong>Office</strong>
            <div>
              {selectedCustomerAccount?.officeCode} -{' '}
              {selectedCustomerAccount?.officeName}
            </div>
          </div>
        </div>
        <div className="grid-col-2 padding-top-0">
          <div className="display-flex flex-column" data-testid="data-section">
            <strong>Customer account</strong>
            <div>{selectedCustomerAccount?.customerAccountId}</div>
            <div>{selectedCustomerAccount?.customerName}</div>
          </div>
        </div>
        <div className="grid-col-2 padding-top-0">
          <div className="display-flex flex-column" data-testid="data-section">
            <strong>Legacy customer number</strong>
            <div>
              <div>{selectedCustomerAccount?.legacyCustomerNumber}</div>
            </div>
          </div>
        </div>
        <div className="grid-col-2 padding-top-0">
          <div className="display-flex flex-column" data-testid="data-section">
            <strong>Default BOAC</strong>
            <div>
              <div>{selectedCustomerAccount?.boac}</div>
            </div>
          </div>
        </div>
        <div className="grid-col-2 padding-top-3">
          <div className="display-flex flex-column" data-testid="data-section">
            <strong>Created by</strong>
            <div className="created-by-email">
              {additionalsDraftData?.createdByUser?.email || emDashUnicode}
            </div>
          </div>
        </div>
        <div className="grid-col-2 padding-top-3">
          <div className="display-flex flex-column" data-testid="data-section">
            <strong>Primary Customer POC</strong>
            <div className="text-wrap text-lowercase created-by-email">
              <div>{selectedCustomerAccount?.customerEmailAddress}</div>
            </div>
          </div>
        </div>
        <div className="grid-col-2 padding-top-3">
          <div className="display-flex flex-column" data-testid="data-section">
            <strong>FSR</strong>
            <div className="text-wrap text-lowercase created-by-email">
              {selectedCustomerAccount?.fsrEmailAddress || emDashUnicode}
            </div>
          </div>
        </div>
        {isGSAEmployee && (
          <div className="grid-col-2 padding-top-3 margin-right-auto">
            <div
              className="display-flex flex-column"
              data-testid="data-section"
            >
              <strong>Funding status</strong>
              <div className="text-wrap">
                {fundingLabel[additionalsDraftData?.fundingStatus] ||
                  emDashUnicode}
              </div>
            </div>
          </div>
        )}
        {isGSAEmployee && additionalsDraftData?.fundingStatus === 'FUNDED' && (
          <div className="grid-col-2 padding-top-3 margin-right-auto">
            <div
              className="display-flex flex-column"
              data-testid="data-section"
            >
              <strong>Funding date</strong>
              <div className="text-wrap">
                {Moment(additionalsDraftData?.fundingDate).format(
                  'MM/DD/YYYY',
                ) || emDashUnicode}
              </div>
            </div>
          </div>
        )}
        {isGSAEmployee && notFunded && (
          <div className="grid-col-2 padding-top-3 margin-right-auto">
            <div
              className="display-flex flex-column"
              data-testid="data-section"
            >
              <strong>Last review date</strong>
              <div className="text-wrap">
                {Moment(additionalsDraftData?.fundingDate).format(
                  'MM/DD/YYYY',
                ) || emDashUnicode}
              </div>
            </div>
          </div>
        )}
        {isGSAEmployee && additionalsDraftData?.fundingStatus === 'FUNDED' && (
          <div className="grid-col-2 padding-top-3 margin-right-auto">
            <div
              className="display-flex flex-column"
              data-testid="data-section"
            >
              <strong> Funding approved by </strong>
              <div className="text-wrap">
                {additionalsDraftData?.fundingApprovedByUser?.fullName ||
                  emDashUnicode}
              </div>
            </div>
          </div>
        )}
        {isGSAEmployee && notFunded && (
          <div className="grid-col-2 padding-top-3 margin-right-auto">
            <div
              className="display-flex flex-column"
              data-testid="data-section"
            >
              <strong> Funding last reviewed by </strong>
              <div className="text-wrap">
                {additionalsDraftData?.fundingApprovedByUser?.fullName ||
                  emDashUnicode}
              </div>
            </div>
          </div>
        )}
        {isGSAEmployee && notFunded && (
          <div className="grid-col-2 padding-top-3 margin-right-auto">
            <div
              className="display-flex flex-column"
              data-testid="data-section"
            >
              <strong> Funding status reason </strong>
              <div className="text-wrap">
                {additionalsDraftData?.fundingStatusReason || emDashUnicode}
              </div>
            </div>
          </div>
        )}
        <div className="grid-col-6"></div>
      </div>
    </>
  );
}
